import React, { useContext, useEffect, useState } from 'react';
import { Context } from '../../../defaults';
import { Tabs } from 'antd';
import {
  getInstitutions,
  getInstitutionById,
  getLanguagesType,
  getTeachersProfile,
  getStudentsWithClass,
  getStudents,
} from '../../../actions';
import { StudentsAdd } from './StudentsAdd';
import { StudentsTable2 } from './StudentsTable2';
import StudentsSwitcher from './StudtensSwitcher';
import jwt from 'jwt-decode';

const { TabPane } = Tabs;

const Students = () => {
  const { dictionary, language } = useContext(Context);
  const [active, setActive] = useState('1');
  const [added, setAdded] = useState('');
  const [institutions, setInstitutions] = useState();
  const [languagesType, setLanguagesType] = useState();
  const [students, setStudents] = useState();

  const callback = (key) => {
    setActive(key);
    setAdded(false);
  };
  const token = localStorage.getItem('token');
  const persistedToken = jwt(token);
  const role = persistedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];

  useEffect(() => {
    getLanguagesType().then(({ data }) => setLanguagesType(data));
    if (role === 'teacher') {
      getTeachersProfile().then(({ data }) => {
        data.institutionId &&
          getInstitutionById(data.institutionId).then(({ data }) => setInstitutions([data]));
        getStudentsWithClass().then(({ data }) => setStudents(data));
      });
    } else {
      getInstitutions().then(({ data }) => setInstitutions(data));
      getStudents().then(({ data }) => setStudents(data));
    }
  }, [added, role]);

  return (
    <Tabs defaultActiveKey="1" activeKey={active} onChange={callback}>
      <TabPane tab={`${dictionary?.AddStudent[language]}`} key="1">
        <StudentsAdd
          institutions={institutions}
          languagesType={languagesType}
          setActive={setActive}
          setAdded={setAdded}
        />
      </TabPane>
      <TabPane tab={dictionary?.StudentList[language]} key="2">
        <div style={{ marginTop: 24 }}>
          <StudentsTable2
            added={added}
            setAdded={setAdded}
            students={students}
            setStudents={setStudents}
            institutions={institutions}
            setInstitutions={setInstitutions}
            languagesType={languagesType}
          />
        </div>
      </TabPane>
      <TabPane tab={dictionary?.ActivatingStudents[language]} key="3">
        <StudentsSwitcher dictionary={dictionary} language={language} />
      </TabPane>
    </Tabs>
  );
};

export default Students;
